<template>
    <div>
        <loading-custom :loading="loading" />
        <div class="tw-flex tw-flex-col tw-p-5">
            <div class="tw-flex tw-justify-between tw-flex-col md:tw-flex-row">
                <div class="tw-flex md:tw-w-1/2 tw-w-full">
                    <div>
                        <img
                            class="product_img"
                            :src="product.image_url"
                            alt=""
                        />
                    </div>
                    <div class="tw-flex tw-flex-col tw-ml-2">
                        <div>
                            <h5>
                                {{ product.name }}
                            </h5>
                        </div>
                        <div class="tw-text-gray-400 tw-text-sm">{{ product.description }}</div>
                        <div>
                            {{
                                `${Number(product.price).toLocaleString(
                                    undefined,
                                    {
                                        minimumFractionDigits: 2
                                    }
                                )} ${currency.name}`
                            }}
                        </div>
                    </div>
                </div>
                <div class="tw-flex tw-flex-col md:tw-w-1/2 tw-w-full">
                    <h5 class="tw-text-center">
                        จำนวนคงเหลือในคลัง
                    </h5>
                    <h1 class="tw-text-center">
                        {{ product.stock_balance }}
                    </h1>
                </div>
            </div>
        </div>
        <div class="row tw-flex-col">
            <div class="col-lg-3 col-6 tw-self-end">
                <div class="form-group">
                    <label class="tw-ml-2">สถานะ</label>
                    <select
                        class="form-control"
                        v-model="search.status"
                        @change="filterData"
                    >
                        <option value="">ทั้งหมด</option>
                        <option value="stock_in">นำเข้า</option>
                        <option value="stock_out">นำออก</option>
                        <option value="order">ออเดอร์</option>
                        <option value="reject">ยกเลิก</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-hover mb-0 c_list">
                <thead>
                    <tr>
                        <th class="">ลำดับ</th>
                        <th class="tw-w-3/12">วันที่ทำรายการ</th>
                        <th class="text-center">
                            จำนวน
                        </th>
                        <th class="text-center">
                            สถานะ
                        </th>
                        <th class="text-center">รายละเอียด</th>
                        <th>หมายเหตุ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-if="
                            tableData.data
                                ? tableData.data.length === 0
                                : tableData.data
                        "
                    >
                        <td class="text-center" colspan="5">
                            ไม่พบข้อมูล
                        </td>
                    </tr>
                    <tr v-for="(item, index) in tableData.data" :key="index">
                        <td>
                            {{ index + 1 }}
                        </td>
                        <td>
                            <div class="tw-flex tw-items-center">
                                <div>
                                    {{ dateFormat(item.created_at) }}
                                </div>
                            </div>
                        </td>
                        <td class="text-center">
                            <div>
                                {{ numberPositive(item.quantity) }}
                            </div>
                        </td>
                        <td class="text-center">
                            <div
                                :class="
                                    `badge 
                            ${item.status == 'stock_in' ? 'badge-success' : ''}
                            ${item.status == 'stock_out' ? 'badge-primary' : ''}
                            ${item.status == 'reject' ? 'badge-danger' : ''}
                            ${item.status == 'order' ? 'badge-warning' : ''}
                            `
                                "
                            >
                                {{ item.status == 'stock_in' ? 'นำเข้า' : ''}}
                                {{ item.status == 'stock_out' ? 'นำออก' : ''}}
                                {{ item.status == 'reject' ? 'ยกเลิก' : ''}}
                                {{ item.status == 'order' ? 'ออเดอร์' : ''}}
                            </div>
                        </td>
                        <td class="text-center">
                            <div>
                                <a :href="`/backend/s/${shop}/orders?name=${item.description}`" target="_blank">
                                    {{ item.description }}  
                                </a>
                            </div>
                        </td>
                        <td>{{ item.remark }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="tw-flex tw-mt-5  tw-justify-center lg:tw-justify-end">
            <paginate
                :data="tableData"
                :page="page"
                @onPage="onPage($event)"
                v-show="tableData.total > 0"
            ></paginate>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import paginate from "../../helper/Paginate.vue";
export default {
    props: ["shop", "product_id"],   
    components: {
        paginate
    },
    data() {
        return {
            product: {},
            page: 1,
            loading: false,
            search: {
                status: ""
            },
            tableData: {}
        };
    },
    mounted() {
        this.getData();
        this.getCurrency();
    },
    methods: {
        numberPositive(number) {
            if (number > 0) {
                return `+${number}`;
            }
            return number;
        },
        onPage(page) {
            this.page = page;
            this.getData();
        },

        updateStock(item) {
            this.productId = item.id;
            this.manageStock = item;
        },
        dateFormat(date) {
            return moment(date).format("DD/MM/YYYY, h:mm:ss a") || "";
        },
        filterData() {
            let query = "";
            this.page = 1;
            Object.keys(this.search).forEach(element => {
                if (this.search[element] != "") {
                    query = `&${query}${element}=${this.search[element]}`;
                }
            });
            if (query != "?") {
                this.getData(query);
            } else {
                this.getData();
            }
        },
        async getData(query = "") {
            this.loading = true;
            await axios
                .get(
                    `/backend/s/${this.shop}/stocks/${this.product_id}/report?page=${this.page}${query}`
                )
                .then(res => {
                    this.tableData = res.data.report;
                    this.product = res.data.product;
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        async getCurrency() {
            this.loading = true;
            await axios
                .get(`/ajax/frontend/s/${this.shop}/currency`)
                .then(res => {
                    this.currency = res.data.currency;
                })
                .catch(err => {
                    console.log(err.response.data);
                })
                .then(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.product_img {
    width: 150px;
}
.badge-primary {
    background: transparent;
    border-color: rgba(59, 130, 246);
    color: rgba(59, 130, 246);
}
</style>
